import { BaseColor } from '@prophecy/ui';
import { DiamondBlue } from '@prophecy/ui/Icons/GemIcons';
function getUnknownGem() {
  return {
    icon: DiamondBlue,
    iconName: 'DiamondBlue',
    tone: BaseColor.blue,
    CategoryName: 'UNKNOWN_GEM'
  } as const;
}

export const UNKNOWN_GEM = getUnknownGem();
export function getUnknownGemName() {
  return getUnknownGem().CategoryName;
}
